import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import { postAPICall } from '../utils/axios.util'
// import { nextAPIRoutes } from '../constants/apiRoutes'
import { handleSnackBar } from "./global";
import MESSAGES from "../constants/messages";
import cardService from "../services/card.service";

export const fetchUserCards = createAsyncThunk(
  "card/fetch",
  async (_: any, { dispatch, getState }) => {
    try {
      const reducer: any = getState();
      if (reducer?.cardReducer?.cards.length === 0) {
        dispatch(setLoadingCards(true));
      }
      const resp: any = await cardService.fetch({}); //postAPICall(nextAPIRoutes.CARD_FETCH, {})
      dispatch(setLoadingCards(false));
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(setLoadingCards(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const createUserCards = createAsyncThunk(
  "card/create",
  async (data: any, { dispatch }) => {
    try {
      dispatch(setCreatingCard(true));
      const resp: any = await cardService.create({ body: data }); //postAPICall(nextAPIRoutes.CARD_CREATE, data)
      dispatch(setCreatingCard(false));
      dispatch(fetchUserCards({}));
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(setCreatingCard(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const updateUserCards = createAsyncThunk(
  "card/updateUserCards",
  async (data: any, { dispatch }) => {
    try {
      dispatch(setCreatingCard(true));
      const resp: any = await cardService.updateById({ body: data }); //postAPICall(nextAPIRoutes.CARD_CREATE, data)
      dispatch(setCreatingCard(false));
      dispatch(fetchUserCards({}));
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(setCreatingCard(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const removeUserCards = createAsyncThunk(
  "card/remove",
  async (data: any, { dispatch }) => {
    try {
      dispatch(setIsDeletion(true));
      const resp: any = await cardService.remove({ body: data }); //postAPICall(nextAPIRoutes.CARD_DELETE, data)
      dispatch(setIsDeletion(false));
      dispatch(fetchUserCards({}));
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(setIsDeletion(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

export const makeDefaultUserCards = createAsyncThunk(
  "card/default",
  async (data: any, { dispatch }) => {
    try {
      dispatch(setIsDeletion(true));
      const resp: any = await cardService.makeDefault({ body: data }); //postAPICall(nextAPIRoutes.CARD_DEFAULT, data)
      dispatch(setIsDeletion(false));
      dispatch(fetchUserCards({}));
      return resp.data.data ?? [];
    } catch (e: any) {
      dispatch(setIsDeletion(false));
      dispatch(
        handleSnackBar({
          open: true,
          severity: "error",
          message: e?.response?.data?.message ?? MESSAGES.ERROR,
        })
      );
      return [];
    }
  }
);

const cardReducer = createSlice({
  name: "card",
  initialState: {
    cards: [],
    loadingCards: false,
    creatingCard: false,
    isDeletion: false,
  },
  reducers: {
    setLoadingCards: (state, { payload }) => {
      state.loadingCards = payload;
    },
    setCreatingCard: (state, { payload }) => {
      state.creatingCard = payload;
    },
    setIsDeletion: (state, { payload }) => {
      state.isDeletion = payload;
    },
    setCards: (state, { payload }) => {
      state.cards = payload;
    },
  },
  extraReducers: (builder) =>
    builder.addCase(fetchUserCards.fulfilled, (state, { payload }) => {
      state.cards = payload;
      state.loadingCards = false;
    }),
});

export default cardReducer.reducer;
export const { setLoadingCards, setCreatingCard, setIsDeletion, setCards } =
  cardReducer.actions;
